import { useContext } from "react";
import { genericMemo } from "../../../../../../utils";
import VisibleColumnsContext from "../contexts/VisibleColumnsContext";
import { BodyRows, RowsProps } from "./BodyRows";
import Loader from "./Loader";
import NoData from "./NoData";

type BodyProps<T extends object> = RowsProps<T> & {
  loading?: boolean,
  pageSize: number,
  showFooter?: boolean,
  hasData?: boolean,
};

export const Body = genericMemo(
  <T extends object>({ loading, hasData, pageSize, showFooter, page, prepareRow, getRowProps }: BodyProps<T>) => {
    const columns = useContext(VisibleColumnsContext);

    if (loading) {
      return <Loader columns={columns.length} rows={showFooter ? pageSize + 1 : pageSize} />;
    }

    return (
      <>
        {
          hasData
            ? <BodyRows page={page} prepareRow={prepareRow} getRowProps={getRowProps} />
            : <NoData />
        }
      </>
    );
  },
);

export default Body;
